import { Component, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { GroupByDateAndDivisionPipe } from '../../../shared/pipes/group-by-date-and-division.pipe';
import { GameService } from '../../../shared/services/game.service';
import { ScheduleService } from '../../../shared/services/schedule.service';
import { SetGameFilterDialogComponent } from '../../set-game-filter/set-game-filter-dialog.component';
import { AddToScheduleDialogComponent } from '../../components/add-to-schedule-dialog/add-to-schedule-dialog.component';
import { GamePageViewModel } from '../../../shared/models/GameModels';


@Component({
  standalone: true,
  selector: 'app-game-list2',
  templateUrl: './game-list2.component.html',
  styleUrls: ['./game-list2.component.css'],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    MatIconModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatButtonModule,
    MatTableModule,
    MatMenuModule,
    ReactiveFormsModule,
    FormsModule,
    GroupByDateAndDivisionPipe
]
})
export class GameList2Component implements OnInit {
  _pageData: GamePageViewModel;
  pastGamesActive: boolean = false;
  isLoading: boolean = false;
  useLocalTimezone: boolean = true;
  GroupByPropertyName: string = "GameDate";
  sort: 'asc' | 'desc' = 'asc';

  gameService: GameService = inject(GameService);
  scheduleService: ScheduleService = inject(ScheduleService);
  private translate: TranslateService = inject(TranslateService);
  private _snackBar: MatSnackBar = inject(MatSnackBar);
  public dialog: MatDialog = inject(MatDialog);

  get timezoneText(): string {
    return this.GroupByPropertyName === 'GameTimeUTC' 
      ? this.translate.instant('TIMEZONE.MY_TIMEZONE') 
      : this.translate.instant('TIMEZONE.LOCAL_TIMEZONES');
  }

  constructor() {}

  ngOnInit() {
    this.getData();
    this.pastGamesActive = false;
    this.GroupByPropertyName = "GameDate";
  }

  getData() {
    this.isLoading = true;
    this.pastGamesActive = false;
    this.sort = 'desc';
    this.gameService.getGames().subscribe(data => {
      this._pageData = data;
      // console.log('Game data:', data); // Felsökning
      this.isLoading = false;
    });
  }

  getPastGames() {
    this.isLoading = true;
    this.pastGamesActive = true;
    this.sort = 'asc';
    this.gameService.getPastGames().subscribe(data => {
      this._pageData = data;
      //console.log('Past game data:', data); // Felsökning
      this.isLoading = false;
    });
  }

  openSetGameFilterDialog(): void {
    const dialogRef = this.dialog.open(SetGameFilterDialogComponent, {
      width: '600px'
    });

    dialogRef.componentInstance.divisionChanged.subscribe(() => {
      this.getData();
    });

    dialogRef.componentInstance.showAllDivisionChanged.subscribe(() => {
      this.getData();
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getData();
      }
    });
  }

  addToSchedule(GameId: string, HomeTeam: string, AwayTeam: string, GameDate: Date, GameTime: Date) {
    const dialogRef = this.dialog.open(AddToScheduleDialogComponent, {
      width: '350px',
      data: {
        GameId: GameId,
        GameDate: GameDate,
        GameTime: GameTime,
        HomeTeam: HomeTeam,
        AwayTeam: AwayTeam
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.openSnackBar("EVENT ADDED", "");
      if (this.pastGamesActive) {
        this.getPastGames();
      } else {
        this.getData();
      }
    });
  }

  removeFromSchedule(GameId: string) {
    this.openSnackBar("EVENT REMOVED", "");
    this.scheduleService.removeEventFromSchedule(GameId).subscribe(() => {
      if (this.pastGamesActive) {
        this.getPastGames();
      } else {
        this.getData();
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  changeBgColor(gameId: string) {
    const element = document.getElementById(gameId);
    if (element) {
      element.style.backgroundColor = '#f0f0f0';
      setTimeout(() => {
        element.style.backgroundColor = '';
      }, 200);
    }
  }

  getIconPath(icon: string): string {

    if (icon.startsWith('/')) {
      return `../assets/img${icon}`;
    } else {
      return `../assets/img/${icon}`;
    }
  }

  handleImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = '../assets/img/placeholder.png';
    imgElement.style.width = '30px';
    imgElement.style.height = '30px';
    imgElement.style.objectFit = 'contain';
  }

  toggleTimezone(timezone: string) {
    this.GroupByPropertyName = timezone;
    this.useLocalTimezone = timezone === 'GameDate';
    if (this.pastGamesActive) {
      this.getPastGames();
    } else {
      this.getData();
    }
  }
}